import { Fragment } from "react";
import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Banner from "../../images/home/marca/suenio/cumpliendo-un-suenio-banner.webp";
import Reloj from "../../images/assets/icon-clock.png";
import Corea from "../../images/home/marca/suenio/cumpliendo-un-suenio-corea.webp";
import Carreteras from "../../images/home/marca/suenio/cumpliendo-un-suenio-carreteras.webp";
import Viaje from "../../images/home/marca/suenio/cumpliendo-un-suenio-viaje.png";
import Coche from "../../images/home/marca/suenio/cumpliendo-un-suenio-coche.png";
import Regreso from "../../images/home/marca/suenio/cumpliendo-un-suenio-regresamos.webp";

function InfoSuenios() {
  return (
    <Fragment>
      <link rel="preload" as="image" href={Banner} />
      <Container fluid={true}>
        <Row>
          <Col md={12} className="px-0">
            <Image src={Banner} alt="Hyundai sueños" title="Hyundai sueños" className="img1" />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md={12}>
            <span className="home-marca-titulo">MARCA</span>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-2 mt-md-0">
            <h1 className="home-casa-titulo">CRECIENDO UN SUEÑO.</h1>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={6}>
            <h2 className="home-autor">
              FOTOS Y PALABRAS HYUNDAI MOTOR EUROPE X EVAN SCHAFIRO
            </h2>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-3">
            <Image
              src={Reloj}
              alt="Icono reloj"
              title="Icono reloj"
              className="home-icono-reloj"
            />
            <h3 className="home-tiempo-lectura ml-2">
              5 minutos de lectura
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-4 mt-md-3">
            <p className="home-texto">
              Hace 70 años, un hombre cumplió su sueño: que mejor era posible. Chung Ju-Yung vio, sintió y vivió los problemas de su país. Fundó
              Hyundai para cumplir los objetivos que tenía para Corea, los sueños que tenía para la humanidad.
            </p>
          </Col>
        </Row>
        <Row className="mt-md-5">
          <Col md={5} className="mt-4 mt-md-3">
            <h3 className="home-titulo-columna">Un sueño de mejor.</h3>
          </Col>
          <Col md={7} className="mt-2 mt-md-3">
            <p className="home-texto-sm">
              Para Ju-Yung, el sueño de ser mejor era la única opción. A los 18 años, llegó a Seúl sin nada y tomó los primeros trabajos que pudo
              encontrar como obrero en un puerto, un obrero de la construcción, un obrero de la fábrica de jarabe. Creció un profundo aprecio por
              el trabajo que mantenía al país funcionando. Cuando consiguió un trabajo como repartidor de una tienda de arroz, rápidamente avanzó
              y se convirtió en jefe de finanzas de la tienda. Le encantaba hacer felices a los clientes y ellos lo amaban. En un par de años,
              Ju-Yung era el dueño de la tienda y la había convertido en un próspero negocio.
            </p>
            <p className="home-texto-sm">
              En 1939, los tiempos eran difíciles. Los militares comenzaron a racionar el arroz y Ju-Yung se quedó de repente fuera del negocio.
              Mientras que muchos se habrían rendido en este punto, Ju-Yung sólo seguía para adelante. Empezó a arreglar autos, compró un garaje de
              servicio a un amigo y rápidamente creció a 70 empleados.
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-4 mt-md-5 px-0 px-md-3">
            <Image src={Corea} width="896" height="480" alt="Hyundai Corea" title="Hyundai Corea" className="img2" />
          </Col>
        </Row>
        <Row className="mt-5 pt-md-4">
          <Col md={7}>
            <p className="home-texto-sm">
              Cuando Corea fue finalmente liberada después de la guerra, Ju-Yung hizo un movimiento rápido y audaz. Fundó Hyundai Civil Industries.
              Sabía que este era el momento de reconstruir Corea, y quería estar al frente de este esfuerzo. Ganó contrato tras contrato,
              incluyendo la construcción de la autopista Gyeongbu.
            </p>
          </Col>
          <Col md={1}></Col>
          <Col md={4} className="mt-4 mt-md-0">
            <h3 className="home-titulo-columna">Un sueño para la humanidad.</h3>
          </Col>
        </Row>
      </Container>
      <Container fluid={true}>
        <Row>
          <Col md={12} className="mt-5 pt-md-3 px-0">
            <Image src={Carreteras} alt="Hyundai carreteras" title="Hyundai carreteras" className="img3" />
          </Col>
        </Row>
      </Container>
      <div className="bg-blue py-4 py-md-5">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12}>
              <h3 className="home-subtitulo-franja text-center">
                Hyundai no comenzó construyendo coches. <br /> Hyundai comenzó construyendo carreteras.
              </h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-brown">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="mt-md-4">
              <Image src={Viaje} alt="Hyundai viaje" title="Hyundai viaje" className="img4" />
            </Col>
          </Row>
          <Row>
            <Col md={4}></Col>
            <Col md={8} className="mt-4 mt-md-5 pt-md-4">
              <p className="home-texto-sm">
                El hecho de que Ju-Yung comenzara con las carreteras es bastante revelador. El viaje es el objetivo. Crea un viaje primero, un
                camino digno de navegar. Deje que los caminos nos guíen a través de nuestras ciudades y se eleven a través de nuestros bosques.
              </p>
              <p className="home-texto-sm">
                Y no te detengas en las carreteras. Construir puertos, puentes. Permitir el acceso a las personas.
              </p>
              <p className="home-texto-sm">
                A continuación, construir el mejor coche para el viaje. Haz del sueño una realidad para la humanidad.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mt-4 mt-md-5 mb-md-4">
              <Image src={Coche} alt="Hyundai coche" title="Hyundai coche" className="img4" />
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="py-4 py-md-5">
        <Row>
          <Col md={6} className="mb-4">
            <h3 className="home-subtitulo">
              Progresamos, <br /> pero nunca olvidamos.
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <p className="home-texto-sm">
              Hyundai nunca dejó de construir. Durante décadas, nuestro objetivo sigue siendo el camino: conectarnos con nuestros paisajes y entre
              nosotros. El progreso está integrado en el espíritu de Hyundai. Progresa pase lo que pase. Porque hemos construido caminos que
              necesitan ser transitados y caminos hacia logros aún por cumplir. Estamos aquí para progresar, para crecer. Por la humanidad. Por tí.
            </p>
          </Col>
          <Col md={1}></Col>
          <Col md={5}>
            <Image src={Regreso} alt="Hyundai regreso" title="Hyundai regreso" className="img5" />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
export default InfoSuenios;